import GeneralUtilsHelper from "@/utils/generalUtils";
import { GetterTree } from "vuex";
import * as types from "@/store/constants/types";
import SuperPayAndBackUpHelpers, {
  TEMP_KEY,
  RECORD_KEY
} from "@/utils/superPayAndBackUp";
import { findLastIndex } from "lodash";

const Getters: GetterTree<any, any> = {
  [types.GETTER_SUPER_PAY_APP_CONFIG](state) {
    return state.superPayAppConfig;
  },
  [types.GETTER_SUPER_PAY_SHOW_ENABLE](state) {
    return state.superPayShowEnable;
  },
  [types.GETTER_SUPER_PAY_APP_HAS_INSTALLED](state) {
    //是否曾经安装过
    return state.superPayAppConfig && state.superPayAppConfig.has_install;
  },
  [types.GETTER_SUPER_PAY_APP_INSTALLED_STATUS](state) {
    //状态
    return state.superPayAppInstalled;
  },
  [types.GETTER_SUPER_PAY_PAY_LAUNCH_SHOW_ENABLE](state, getters) {
    return () => {
      if (getters[types.GETTER_SUPER_PAY_SHOW_ENABLE]) {
        const settingData: any = getters[types.GETTER_SETTING_DATA];
        const spacingCount =
          settingData.super_pay.launch_modal.spacing_show_times;
        const maxShowCount =
          settingData.super_pay.launch_modal.total_show_times;
        const launchTimes = getters[types.GETTER_APP_LAUNCH_TIME];
        const vipShowTimes = SuperPayAndBackUpHelpers.getTempKeyTimes(
          TEMP_KEY.VIP_CENTER_SHOW_TIMES
        );
        //pre vip times:
        const previpShowTimesThrold =
          settingData.super_pay.launch_modal.pre_continuously_vip_times;
        //队列：
        const launchRecordQueue: any = SuperPayAndBackUpHelpers.getLocalKeyTimes(
          RECORD_KEY.LAUNCH_PAGE_SUPER_OR_BACK_OR_VIP_SHOW_RECORD
        );
        //super_pay index:
        const findLastSuperPayShowIndex = findLastIndex(
          launchRecordQueue,
          (record: any) => {
            return record.name === "super_pay";
          }
        );
        const lastSuperPayShowIndex =
          findLastSuperPayShowIndex === -1
            ? -1
            : launchRecordQueue[findLastSuperPayShowIndex].index;
        //back_up index:
        const findLastBackUpShowIndex = findLastIndex(
          launchRecordQueue,
          (record: any) => {
            return record.name === "back_up";
          }
        );
        const lastBackUpShowIndex =
          findLastBackUpShowIndex === -1
            ? -1
            : launchRecordQueue[findLastBackUpShowIndex].index;
        //continus vip times:
        let vipContinusShowTimes: number = 0;
        launchRecordQueue.forEach((record: any) => {
          if (record.name === "vip") {
            vipContinusShowTimes += 1;
          }
        });

        let superPayContinusShowTimes: number = 0;
        launchRecordQueue.forEach((record: any) => {
          if (record.name === "super_pay") {
            superPayContinusShowTimes += 1;
          }
        });

        console.log("GETTER_SUPER_PAY_PAY_LAUNCH_SHOW_ENABLE:", {
          spacingCount,
          launchTimes,
          vipShowTimes,
          previpShowTimesThrold,
          lastSuperPayShowIndex,
          lastBackUpShowIndex,
          launchRecordQueue,
          vipContinusShowTimes
        });

        //如果显示过vip，则不显示luanch:
        if (vipShowTimes >= 1) {
          return false;
        }

        //max show
        if (superPayContinusShowTimes >= maxShowCount) {
          return false;
        }

        if (GeneralUtilsHelper.isVip()) {
          //vip用户,检查上一次的index:
          if (lastSuperPayShowIndex === -1) {
            return true;
          } else if (launchTimes - 1 - lastSuperPayShowIndex >= spacingCount) {
            return true;
          } else {
            return false;
          }
        } else {
          //非vip用户:
          if (vipContinusShowTimes >= previpShowTimesThrold) {
            if (lastSuperPayShowIndex === -1) {
              return true;
            } else if (
              //要自身的显示做比较
              launchTimes - 1 - lastSuperPayShowIndex >=
              spacingCount
            ) {
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        }
      } else {
        return false;
      }
    };
  },
  [types.GETTER_SUPER_PAY_PAY_RESULT_PAGE_SHOW_ENABLE](state, getters) {
    //page recoomend是否显示
    return () => {
      //super pay
      if (getters[types.GETTER_SUPER_PAY_SHOW_ENABLE]) {
        //支付显示的队列数组:
        const payResultRecordQueue: any = SuperPayAndBackUpHelpers.getLocalKeyTimes(
          RECORD_KEY.PAY_RESULT_SUPER_OR_BACK_RECOMMEND_SHOW_RECORD
        );
        //setting:
        const settingData: any = getters[types.GETTER_SETTING_DATA];
        console.log("payResultRecordQueue:", payResultRecordQueue);
        //suer pay index:
        const findLastSuperPayIndex = findLastIndex(
          payResultRecordQueue,
          (record: string) => {
            return record === "super_pay";
          }
        );
        //back up index:
        const findLastBackUpIndex = findLastIndex(
          payResultRecordQueue,
          (record: string) => {
            return record === "back_up";
          }
        );
        //superpay continus throld:
        const superPayContinusThrold =
          settingData.super_pay.pay_result_page.continuous_show_times;
        //superpay  continus
        const suerPayContinusTimes = GeneralUtilsHelper.findContinusTimesShowName(
          "super_pay",
          "back_up",
          payResultRecordQueue
        );

        //backup continus throld:
        const backUpContinusThrold =
          settingData.back_up.pay_result_page.continuous_show_times;
        //back up continus
        const backUpContinusTimes = GeneralUtilsHelper.findContinusTimesShowName(
          "back_up",
          "super_pay",
          payResultRecordQueue
        );

        //spcacing times:
        let spacingTimes: any =
          settingData.super_pay.pay_result_page.spacing_show_times;

        console.log("GETTER_SUPER_PAY_PAY_RESULT_PAGE_SHOW_ENABLE:", {
          payResultRecordQueue,
          superPayContinusThrold,
          backUpContinusThrold,
          findLastSuperPayIndex,
          findLastBackUpIndex,
          suerPayContinusTimes,
          backUpContinusTimes
        });
        if (!getters[types.GETTER_BACK_UP_APP_SHOW_ENABLE]) {
          //back up达不到条件
          console.log("back up达不到条件");
          spacingTimes =
            settingData.super_pay.pay_result_page.spacing_show_times_single;
          if (findLastSuperPayIndex === -1) {
            console.log("findLastSuperPayIndex ==-1");
            return true;
          } else if (
            payResultRecordQueue.length - 1 - findLastSuperPayIndex ===
            spacingTimes
          ) {
            return true;
          } else {
            return false;
          }
        } else {
          //两个同时显示:
          //1.back up 在末尾
          //2.superpay 在末尾
          if (findLastBackUpIndex > findLastSuperPayIndex) {
            //有back up在末尾
            console.log("有back up在末尾");
            if (
              backUpContinusTimes >= backUpContinusThrold &&
              payResultRecordQueue.length - 1 - findLastBackUpIndex ===
                spacingTimes
            ) {
              //检查back ups是否达到连续，间隔是否达到
              return true;
            } else {
              return false;
            }
          } else if (findLastSuperPayIndex > findLastBackUpIndex) {
            //super pay在末尾，检查superpay连续性
            console.log("super pay在末尾，检查superpay连续性");
            if (
              suerPayContinusTimes < superPayContinusThrold &&
              payResultRecordQueue.length - 1 - findLastSuperPayIndex ===
                spacingTimes
            ) {
              //检查back ups是否达到连续，间隔是否达到
              return true;
            } else {
              return false;
            }
          } else {
            //index相等，一种情况就是都为0:
            console.log("index相等，一种情况就是都为0:");
            return true;
          }
        }
      } else {
        return false;
      }
    };
  },
  [types.GETTER_SUPER_PAY_PAY_RESULT_PAGE_CLOSE_SHOW_ENABLE](state, getters) {
    //page close是否显示
    return () => {
      //super pay
      if (getters[types.GETTER_SUPER_PAY_SHOW_ENABLE]) {
        //支付显示的队列数组:
        const payResultRecordQueue: any = SuperPayAndBackUpHelpers.getLocalKeyTimes(
          RECORD_KEY.PAY_RESULT_PAGE_CLOSE_SUPER_OR_BACK_DIALOG_SHOW_RECORD
        );
        //setting:
        const settingData: any = getters[types.GETTER_SETTING_DATA];
        console.log("payResultRecordQueue:", payResultRecordQueue);
        //suer pay index:
        const findLastSuperPayIndex = findLastIndex(
          payResultRecordQueue,
          (record: string) => {
            return record === "super_pay";
          }
        );
        //back up index:
        const findLastBackUpIndex = findLastIndex(
          payResultRecordQueue,
          (record: string) => {
            return record === "back_up";
          }
        );
        //superpay continus throld:
        const superPayContinusThrold =
          settingData.super_pay.pay_result_close.continuous_show_times;
        //superpay  continus
        const suerPayContinusTimes = GeneralUtilsHelper.findContinusTimesShowName(
          "super_pay",
          "back_up",
          payResultRecordQueue
        );

        //backup continus throld:
        const backUpContinusThrold =
          settingData.back_up.pay_result_close.continuous_show_times;
        //back up continus
        const backUpContinusTimes = GeneralUtilsHelper.findContinusTimesShowName(
          "back_up",
          "super_pay",
          payResultRecordQueue
        );

        //spcacing times:
        let spacingTimes: any =
          settingData.super_pay.pay_result_close.spacing_show_times;

        console.log("GETTER_SUPER_PAY_PAY_RESULT_PAGE_SHOW_ENABLE:", {
          payResultRecordQueue,
          superPayContinusThrold,
          backUpContinusThrold,
          findLastSuperPayIndex,
          findLastBackUpIndex,
          suerPayContinusTimes,
          backUpContinusTimes
        });
        if (!getters[types.GETTER_BACK_UP_APP_SHOW_ENABLE]) {
          //back up达不到条件
          console.log("back up达不到条件");
          spacingTimes =
            settingData.super_pay.pay_result_close.spacing_show_times_single;
          if (findLastSuperPayIndex === -1) {
            console.log("findLastSuperPayIndex ==-1");
            return true;
          } else if (
            payResultRecordQueue.length - 1 - findLastSuperPayIndex ===
            spacingTimes
          ) {
            return true;
          } else {
            return false;
          }
        } else {
          //两个同时显示:
          //1.back up 在末尾
          //2.superpay 在末尾
          if (findLastBackUpIndex > findLastSuperPayIndex) {
            //有back up在末尾
            console.log("有back up在末尾");
            if (
              backUpContinusTimes >= backUpContinusThrold &&
              payResultRecordQueue.length - 1 - findLastBackUpIndex ===
                spacingTimes
            ) {
              //检查back ups是否达到连续，间隔是否达到
              return true;
            } else {
              return false;
            }
          } else if (findLastSuperPayIndex > findLastBackUpIndex) {
            //super pay在末尾，检查superpay连续性
            console.log("super pay在末尾，检查superpay连续性");
            if (
              suerPayContinusTimes < superPayContinusThrold &&
              payResultRecordQueue.length - 1 - findLastSuperPayIndex ===
                spacingTimes
            ) {
              //检查back ups是否达到连续，间隔是否达到
              return true;
            } else {
              return false;
            }
          } else {
            //index相等，一种情况就是都为0:
            console.log("index相等，一种情况就是都为0:");
            return true;
          }
        }
      } else {
        return false;
      }
    };
  },
  [types.GETTER_SUPER_PAY_SWITCH_TO_IAP_DIALOG_SHOW_ENABLE](state, getters) {
    return () => {
      if (getters[types.GETTER_SUPER_PAY_SHOW_ENABLE]) {
        const settingData: any = getters[types.GETTER_SETTING_DATA];
        console.log(
          "TEMP_SWITCH_TO_IAP_TIMES",
          SuperPayAndBackUpHelpers.getTempKeyTimes(
            TEMP_KEY.TEMP_SWITCH_TO_IAP_TIMES
          )
        );
        if (
          settingData.super_pay.dialog_enable.super_pay_switch_to_iap &&
          SuperPayAndBackUpHelpers.getTempKeyTimes(
            TEMP_KEY.TEMP_SUPER_PAY_DIALOG_OR_RETAIN_SHOW_TIMES
          ) < 1 && //这个次数是后记下的，然后下次判断
          SuperPayAndBackUpHelpers.getTempKeyTimes(
            TEMP_KEY.TEMP_SWITCH_TO_IAP_TIMES
          ) <= 1
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    };
  },
  [types.GETTER_SUPER_PAY_PAYMENT_IAP_CANCEL_DIALOG_ENABLE](state, getters) {
    return () => {
      if (getters[types.GETTER_SUPER_PAY_SHOW_ENABLE]) {
        const settingData: any = getters[types.GETTER_SETTING_DATA];
        console.log(
          "GETTER_SUPER_PAY_PAYMENT_CLOSE_SHOW_RETAIN_ENABLE",
          SuperPayAndBackUpHelpers.getTempKeyTimes(
            TEMP_KEY.TEMP_IAP_CANCEL_TIMES
          )
        );
        if (
          settingData.super_pay.dialog_enable.iap_cancel &&
          SuperPayAndBackUpHelpers.getTempKeyTimes(
            TEMP_KEY.TEMP_SUPER_PAY_DIALOG_OR_RETAIN_SHOW_TIMES
          ) < 1 && //这个次数是后记下的，然后下次判断
          SuperPayAndBackUpHelpers.getTempKeyTimes(
            TEMP_KEY.TEMP_IAP_CANCEL_TIMES
          ) <= 1 //次数是先记下+，然后判断，当前先+1，然后判断，所以要<=1
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    };
  },
  [types.GETTER_SUPER_PAY_PAYMENT_CLOSE_SHOW_RETAIN_ENABLE](state, getters) {
    return () => {
      if (getters[types.GETTER_SUPER_PAY_SHOW_ENABLE]) {
        const settingData: any = getters[types.GETTER_SETTING_DATA];
        console.log(
          "GETTER_SUPER_PAY_PAYMENT_CLOSE_SHOW_RETAIN_ENABLE",
          SuperPayAndBackUpHelpers.getTempKeyTimes(
            TEMP_KEY.TEMP_PAYMEN_CLOSE_TIMES
          )
        );
        if (
          settingData.super_pay.dialog_enable.payment_close &&
          SuperPayAndBackUpHelpers.getTempKeyTimes(
            TEMP_KEY.TEMP_SUPER_PAY_DIALOG_OR_RETAIN_SHOW_TIMES
          ) < 1 && //这个次数是后记下的，然后下次判断
          SuperPayAndBackUpHelpers.getTempKeyTimes(
            TEMP_KEY.TEMP_PAYMEN_CLOSE_TIMES
          ) <= 1
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    };
  },
  [types.GETTER_SUPER_PAY_PAYMENT_SHOW_ENABLE](state, getters) {
    return (offer: any) => {
      if (
        offer &&
        offer.pay_data &&
        offer.pay_data.super_pay &&
        getters[types.GETTER_SUPER_PAY_APP_SHOW_OTHER_CONDITION]() &&
        getters[types.GETTER_SUPER_PAY_APP_CONFIG] &&
        getters[types.GETTER_SUPER_PAY_PARAMS] &&
        getters[types.GETTER_SUPER_PAY_APP_CONFIG_INTERFACE_ENABLE]
      ) {
        //有params 有config 有condition 有pay_data 接口能用superpay
        return true;
      } else {
        return false;
      }
    };
  },
  [types.GETTER_SUPER_PAY_APP_SHOW_OTHER_CONDITION](state, getters) {
    return () => {
      const settingData: any = getters[types.GETTER_SETTING_DATA];
      const launchTime: number = getters[types.GETTER_APP_LAUNCH_TIME];
      const firstLaunchAppStamp: number =
        getters[types.GETTER_FIRST_ENTER_TIMESTAMP];

      let params: any = {};
      if (
        settingData.features &&
        settingData.features.find((feature: any) => {
          return feature.function === "superpay_way";
        })
      ) {
        params = settingData.features.find((feature: any) => {
          return feature.function === "superpay_way";
        });
      } else {
        params = {
          event: [
            {
              count: 1,
              eventName: "pay_by_iap"
            }
          ]
        };
      }

      if (!params.hasOwnProperty("delay")) {
        //如果没有配置delay默认不显示
        return false;
      } else {
        if (new Date().valueOf() - firstLaunchAppStamp < params.delay * 1000) {
          //delay拦击，如果时间差小于规定，不显示
          return false;
        }
      }

      //判断条件：
      const { event } = params;
      let nesscaryTime: number = 0;
      let nesscaryThrold: number = 0;
      for (const condition of event) {
        if (!condition.eventName.includes("or")) {
          nesscaryThrold += 1;
        }
        if (
          condition.eventName === "or_open_app" &&
          launchTime >= condition.count
        ) {
          console.log("GETTER_SUPER_PAY_APP_SHOW_OTHER_CONDITION 达到打开次数");
          return true;
        } else {
          //必要条件:
          switch (condition.eventName) {
            case "open_app": {
              if (launchTime >= condition.count) {
                nesscaryTime += 1;
              }
              break;
            }
            case "pay_by_iap": {
              if (
                getters[types.GETTER_PURCHASED_TIME]("iap") >= condition.count
              ) {
                nesscaryTime += 1;
              }
              break;
            }
            case "pay_by_cash": {
              if (
                getters[types.GETTER_PURCHASED_TIME]("cash") >= condition.count
              ) {
                nesscaryTime += 1;
              }
              break;
            }
            default:
              break;
          }
        }
      }
      if (nesscaryTime >= nesscaryThrold) {
        console.log(
          "GETTER_SUPER_PAY_APP_SHOW_OTHER_CONDITION 达到多个条件:",
          nesscaryTime,
          nesscaryThrold
        );
        return true;
      } else {
        console.log(
          "GETTER_SUPER_PAY_APP_SHOW_OTHER_CONDITION 没有达到多个条件",
          nesscaryTime,
          nesscaryThrold
        );
        return false;
      }
    };
  },
  [types.GETTER_SUPER_PAY_APP_DESC](state, getters) {
    return ({ color = "rgb(12,195,191)" }: any = {}) => {
      const superPayAppParams = getters[types.GETTER_SUPER_PAY_PARAMS];
      if (superPayAppParams.description && superPayAppParams.description.desc) {
        let defaultDes = superPayAppParams.description.desc;
        if (superPayAppParams.description.desc_highlight) {
          //存在高亮：
          superPayAppParams.description.desc_highlight.forEach(
            (lihgtWord: string) => {
              if (defaultDes.includes(lihgtWord)) {
                defaultDes = defaultDes.replace(
                  lihgtWord,
                  `<i style="color:${color}">${lihgtWord}</i>`
                );
              }
            }
          );
        }
        return defaultDes;
      } else {
        return "";
      }
    };
  },
  [types.GETTER_SUPER_PAY_APP_DESC_LIST](state, getters) {
    return ({ color = "rgb(12,195,191)" }: any = {}) => {
      const superPayAppParams = getters[types.GETTER_SUPER_PAY_PARAMS];
      if (
        superPayAppParams.description &&
        superPayAppParams.description.desc_list
      ) {
        const defaultDesList = superPayAppParams.description.desc_list;
        const newDescList: any = [];
        if (superPayAppParams.description.desc_list_highlight) {
          //存在高亮：
          defaultDesList.forEach((wordString: string) => {
            for (const word of superPayAppParams.description
              .desc_list_highlight) {
              console.log("word:", word);
              if (wordString.includes(word)) {
                wordString = wordString.replace(
                  word,
                  `<i style="color:${color}">${word}</i>`
                );
              }
            }
            newDescList.push(wordString);
          });
        }
        console.log("newDescList:", newDescList);
        return newDescList;
      } else {
        return [];
      }
    };
  },
  [types.GETTER_SUPER_PAY_APP_CONFIG_INTERFACE_ENABLE](state, getters) {
    return state.superPayConfigInterfaceEnable;
  }
};
export default Getters;
